import { useBillingStatusContent } from "./useBillingStatusContent";
import { BillingNudgeAlert } from "./BillingNudgeAlert";
import { TrialSalesNudge } from "./TrialSalesNudge/TrialSalesNudge";
import { UpdateAvailableNudge } from "./UpdateAvailableNudge";

export const NavDrawerNudge = () => {
  const billingContent = useBillingStatusContent();
  if (billingContent?.actionType === "book-sales-call") {
    return <TrialSalesNudge content={billingContent} />;
  }
  if (billingContent) {
    return <BillingNudgeAlert />;
  }
  return <UpdateAvailableNudge />;
};
